export default function FormIcon() {
    return (
        <svg width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 0C1.34315 0 0 1.34315 0 3V25C0 26.6569 1.34315 28 3 28H19C20.6569 28 22 26.6569 22 25V8.82843C22 8.03278 21.6839 7.26972 21.1213 6.70711L15.2929 0.87868C14.7303 0.31607 13.9672 0 13.1716 0H3ZM2 3C2 2.44772 2.44772 2 3 2H12V7C12 8.65685 13.3431 10 15 10H20V25C20 25.5523 19.5523 26 19 26H3C2.44772 26 2 25.5523 2 25V3ZM19.5858 8H15C14.4477 8 14 7.55228 14 7V2.41421L19.5858 8Z" fill="white"/>
        </svg>
    );
};